define('plugin/package/view/PackageModuleListView',['require','lib/view/BaseCompositeView','plugin/package/view/PackageModuleItemView','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('lib/view/BaseCompositeView');
    var PackageModuleItemView = require('plugin/package/view/PackageModuleItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Package list module
     *
     * @class PackageModuleListView
     */
    return Parent.extend({

        template: '#package_module_list_view',
        childView: PackageModuleItemView,
        childViewContainer: '#sb_package_module_list_container',

        childViewOptions: function (model, index) {
            return  {
                serviceCollection: this.getOption('serviceCollection'),
                productCollection: this.getOption('productCollection'),
                attributeCollection: this.getOption('attributeCollection'),
            };
        },

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        collectionEvents: {
            'sync': 'render'
        },

        limit: 4,
        _ids: [],

        _moduleId: 'package',

        initialize: function () {

        },

        filter: function (model) {
            if (_.indexOf(this._ids, model.get('id')) === -1) {
                return false;
            }
            return true;
        },

        onBeforeRender: function () {
            if (this.$el && this.$el.parent().length) {
                var count = this.$el.parent().data('sb-count');
                if (parseInt(count) && parseInt(count) != this.limit) {
                    this.limit = parseInt(count);
                }
            }

            this._ids = this.collection.pluck('id').slice(0, this.limit);
        }

    });

});
